import React from "react";
import {
  CarbonAvoidanceProjectSubType,
  CarbonAvoidanceProjectType,
  ForestrySubType,
  RenewablesSubType,
} from "@ecologi/shared";
import CaptureIcon from "@ecologi/assets/icons/ProjectInsights/capture.svg";
import CommunityIcon from "@ecologi/assets/icons/ProjectInsights/community.svg";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";
import RenewablesIcon from "@ecologi/assets/icons/ProjectInsights/renewables.svg";
import TransportIcon from "@ecologi/assets/icons/ProjectInsights/transport.svg";
import WetlandsIcon from "@ecologi/assets/icons/ProjectInsights/wetlands.svg";
import { ProjectVisualsType } from "./project-visuals";

const PATH = "/images/app/forest/carbon_avoidance/pictograms/";

export const carbonAvoidanceVisuals: Record<
  CarbonAvoidanceProjectType,
  ProjectVisualsType
> = {
  [CarbonAvoidanceProjectType.Capture]: {
    icon: <CaptureIcon />,
    pictogram: `${PATH}capture.svg`,
  },
  [CarbonAvoidanceProjectType.Community]: {
    icon: <CommunityIcon />,
    pictogram: `${PATH}community.svg`,
  },
  [CarbonAvoidanceProjectType.Forestry]: {
    icon: <ForestryIcon />,
    pictogram: `${PATH}forestry.svg`,
  },
  [CarbonAvoidanceProjectType.Renewables]: {
    icon: <RenewablesIcon />,
    pictogram: "",
  },
  [CarbonAvoidanceProjectType.Transport]: {
    icon: <TransportIcon />,
    pictogram: `${PATH}transport.svg`,
  },
  [CarbonAvoidanceProjectType.Wetlands]: {
    icon: <WetlandsIcon />,
    pictogram: `${PATH}wetlands.svg`,
  },
  // Geothermal is waiting on finalised designs and currently shares the renewables icon.
  [CarbonAvoidanceProjectType.Geothermal]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [CarbonAvoidanceProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [CarbonAvoidanceProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};

export const carbonAvoidanceSubTypeVisuals: Record<
  CarbonAvoidanceProjectSubType,
  ProjectVisualsType
> = {
  // Biomass, Hydro and Solar are waiting on finalised designs and currently share the renewables icon.
  [RenewablesSubType.Biomass]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [RenewablesSubType.Hydro]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [RenewablesSubType.Solar]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  [RenewablesSubType.Wind]: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}wind.svg`,
  },
  [ForestrySubType.ForestProtection]: {
    icon: <ForestryIcon />,
    pictogram: `${PATH}forestry.svg`,
  },
};
